<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import PagesTable from './PagesTable';

export default {
  page: {
    title: 'Pages',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, PagesTable },
  data() {
    return {
      title: 'Pages',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Pages', active: true, },
      ],

      loading: true,
      filters: {
        whereins: {
          website: [],
        },
      }
    }
  },
  created() {
    this.filters.whereins.website = [this.website_id];
  },
  methods: {
    
  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id" :key="$route.fullPath"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <div class="card-box p-0 position-relative">
            <PagesTable ref="PagesTable" :changefilters="filters"  @loadchange="(e) => {loading = e;}"></PagesTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
